<template>
  <div>
    <tablegeneric
      :headers="headers"
      :formfields="formfields"
      url="/admin/acessomodulos"
      incluir="acesso_modulo_incluir"
      editar="acesso_modulo_editar"
      excluir="acesso_modulo_excluir"
      exportar="acesso_modulo_exportar p/excel"
      imprimir="acesso_modulo_imprimir"
      clonar="acesso_modulo_clonar"
    />
  </div>
</template>

<script>
import headers from './headers.mixins'
import formfields from './formfields.mixins'

export default {
  name: 'Home',
  components: {
    tablegeneric: () => import('@/components/tablegeneric')
  },
  mixins: [
    headers,
    formfields
  ]
}
</script>

<style>
</style>
